import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { RefreshCwIcon, PlusIcon, UserPlusIcon, UserMinusIcon, CheckIcon, XIcon } from 'lucide-react';
export function SubaccountsTab() {
  // Mock data for subaccounts
  const [subaccounts, setSubaccounts] = useState([{
    id: '1',
    firstName: 'Emma',
    lastName: 'Johnson',
    age: 16,
    gender: 'Female',
    mobile: '+1 (555) 234-5678'
  }, {
    id: '2',
    firstName: 'Noah',
    lastName: 'Johnson',
    age: 12,
    gender: 'Male',
    mobile: '+1 (555) 876-5432'
  }, {
    id: '3',
    firstName: 'Olivia',
    lastName: 'Johnson',
    age: 8,
    gender: 'Female',
    mobile: 'N/A'
  }]);
  const [selectedSubaccounts, setSelectedSubaccounts] = useState([]);
  const toggleSelectSubaccount = id => {
    if (selectedSubaccounts.includes(id)) {
      setSelectedSubaccounts(selectedSubaccounts.filter(sid => sid !== id));
    } else {
      setSelectedSubaccounts([...selectedSubaccounts, id]);
    }
  };
  const handleRefresh = () => {
    // In a real app, this would fetch the latest subaccounts
    console.log('Refreshing subaccounts...');
  };
  const handleSelectAll = () => {
    if (selectedSubaccounts.length === subaccounts.length) {
      setSelectedSubaccounts([]);
    } else {
      setSelectedSubaccounts(subaccounts.map(sub => sub.id));
    }
  };
  return <div data-id="element-420">
      <Card title="Subaccounts" data-id="element-421">
        <div className="mb-4 flex flex-wrap items-center gap-2" data-id="element-422">
          <button onClick={handleRefresh} className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-sm" data-id="element-423">
            <RefreshCwIcon className="w-4 h-4" data-id="element-424" />
            <span data-id="element-425">Refresh</span>
          </button>
          <button className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-426">
            <PlusIcon className="w-4 h-4" data-id="element-427" />
            <span data-id="element-428">New</span>
          </button>
          <button className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm" data-id="element-429">
            <UserPlusIcon className="w-4 h-4" data-id="element-430" />
            <span data-id="element-431">Add Existing</span>
          </button>
          <button disabled={selectedSubaccounts.length === 0} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-colors text-sm ${selectedSubaccounts.length > 0 ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`} data-id="element-432">
            <UserMinusIcon className="w-4 h-4" data-id="element-433" />
            <span data-id="element-434">Remove</span>
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-435">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-436">
            <thead data-id="element-437">
              <tr data-id="element-438">
                <th className="px-3 py-2 text-left" data-id="element-439">
                  <div className="flex items-center" data-id="element-440">
                    <input type="checkbox" className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" checked={selectedSubaccounts.length === subaccounts.length && subaccounts.length > 0} onChange={handleSelectAll} data-id="element-441" />
                  </div>
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-442">
                  First Name
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-443">
                  Last Name
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-444">
                  Age
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-445">
                  Gender
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-446">
                  Mobile
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-447">
              {subaccounts.map(subaccount => <tr key={subaccount.id} className={`hover:bg-gray-50 ${selectedSubaccounts.includes(subaccount.id) ? 'bg-blue-50' : ''}`} data-id="element-448">
                  <td className="px-3 py-3 text-sm" data-id="element-449">
                    <input type="checkbox" className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" checked={selectedSubaccounts.includes(subaccount.id)} onChange={() => toggleSelectSubaccount(subaccount.id)} data-id="element-450" />
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-451">
                    {subaccount.firstName}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-452">
                    {subaccount.lastName}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-453">
                    {subaccount.age}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-454">
                    {subaccount.gender}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-455">
                    {subaccount.mobile}
                  </td>
                </tr>)}
              {subaccounts.length === 0 && <tr data-id="element-456">
                  <td colSpan={6} className="px-3 py-4 text-sm text-gray-500 text-center" data-id="element-457">
                    No subaccounts found
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}